import type {
  memberListInterface,
  bannerCPMicInterface
} from '@/types/apiType/roomType'
import type { giftSendResponseInterface } from '@/types/apiType/giftType'

export const useAnimationStore = defineStore({
  id: 'animation',
  state: () => ({
    /** 横幅-进房 */
    bannerEnterRooms: [] as memberListInterface[],
    /** 麦位礼物 */
    micGifts: [] as giftSendResponseInterface[], // 麦位礼物
    /** 侧边礼物列表 */
    giftListAnimation: [] as giftSendResponseInterface[], // 侧边礼物列表
    /** 特效礼物 || 或进房特效 */
    effectGifts: [] as giftSendResponseInterface[],
    /** PC上麦横幅 */
    bannerCPMic: [] as bannerCPMicInterface[]
  }),
  actions: {
    /** 送礼socket回调接听 */
    onGiftSend(data: giftSendResponseInterface) {
      const roomStore = useRoomStore()
      if (roomStore.roomId) {
        // 唯一ID `${data.comboId}${data.giftId}${data.uid}${data.targetUids?.join('')}`
        data.id = `${data.comboId}${data.giftInfo.giftId}${data.uid}${data.targetUids ? data.targetUids?.join('') : data.targetUid}`
        data.micId = `${data.comboId}${new Date().getTime()}`

        // 侧边栏礼物
        this.setGiftListAnimation(data)
        // 设置麦位礼物
        this.setMicGifts(data)
        // 设置特效礼物
        this.setEffectGifts(data)
      }
    },
    //#region 特效礼物
    /** 设置特效礼物 */
    setEffectGifts(data: giftSendResponseInterface) {
      const publicStore = usePublicStore()
      if (
        publicStore.isPageVisible &&
        ((data.giftInfo.vggUrl && data.giftInfo.hasEffect) ||
          (data.giftInfo.videoUrl && data.giftInfo.isVideo))
      ) {
        this.effectGifts.push(data)
      }
    },
    /** 设置特效座驾 */
    setEffectCar(data: giftSendResponseInterface) {
      const publicStore = usePublicStore()
      if (
        publicStore.isPageVisible &&
        (data.carUrl || data.carVideoUrl) &&
        this.effectGifts.length === 0
      ) {
        this.effectGifts.push(data)
      }
    },
    /**
     * 移除动画特效子集
     * @param {shift} type '移除类型：shift：第一项'
     * */
    removeEffectGifts(params: { type: 'shift' }) {
      if (params.type === 'shift') {
        this.effectGifts.shift()
      }
    },
    //#endregion
    //#region 侧边礼物列表
    setGiftListAnimation(data: giftSendResponseInterface) {
      const publicStore = usePublicStore()
      const index = this.giftListAnimation.findIndex((v) => v.id === data.id)
      // 有特效就不播了
      if (
        publicStore.isPageVisible &&
        !(
          (data.giftInfo.vggUrl && data.giftInfo.hasEffect) ||
          (data.giftInfo.videoUrl && data.giftInfo.isVideo)
        )
      ) {
        if (index === -1) {
          this.giftListAnimation.push(data)
        } else {
          this.giftListAnimation.splice(index, 1, data)
        }
      }
    },
    // 移除侧边礼物列表某一项
    removeGiftListAnimation(comboId: number) {
      const index = this.giftListAnimation.findIndex(
        (v) => v.comboId === comboId
      )
      this.giftListAnimation.splice(index, 1)
    },
    //#endregion
    //#region 麦位礼物
    /** 设置麦位礼物 */
    setMicGifts(data: giftSendResponseInterface) {
      const roomStore = useRoomStore()
      const publicStore = usePublicStore()
      //  麦位礼物 0 是开启,有特效就不播了
      if (
        publicStore.isPageVisible &&
        roomStore.socketRoomInfo.giftEffectSwitch === 0 &&
        !(
          (data.giftInfo.vggUrl && data.giftInfo.hasEffect) ||
          (data.giftInfo.videoUrl && data.giftInfo.isVideo)
        )
      ) {
        this.micGifts.push(data)
      }
    },
    /** 移除麦位礼物列表某一项 */
    removeMicGifts(micId: string) {
      const index = this.micGifts.findIndex((v) => v.micId === micId)
      if (index !== -1) {
        this.micGifts.splice(index, 1)
      }
    },
    //#endregion
    //#region 横幅
    /**
     * 设置进房横幅
     * @param  {shift | init | push} type 类型：shift：移除第一项, init：初始化，push：添加data
     */
    setBannerEnterRooms(
      type: 'shift' | 'init' | 'push',
      data?: memberListInterface
    ) {
      const publicStore = usePublicStore()
      switch (type) {
        case 'init':
          this.bannerEnterRooms = []
          break
        case 'shift':
          this.bannerEnterRooms.shift()
          break
        case 'push':
          if (data && publicStore.isPageVisible) {
            this.bannerEnterRooms.push(data)
          }
          break
      }
    },
    /**  设置横幅CP上麦
     *  * @param  {shift | init | push} type 类型：shift：移除第一项, init：初始化，push：添加data
     */
    setBannerCPMic(
      type: 'shift' | 'init' | 'push',
      data?: bannerCPMicInterface
    ) {
      const publicStore = usePublicStore()
      switch (type) {
        case 'init':
          this.bannerCPMic = []
          break
        case 'shift':
          this.bannerCPMic.shift()
          break
        case 'push':
          if (data && publicStore.isPageVisible) {
            this.bannerCPMic.push(data)
          }
          break
      }
    },
    //#endregion
    /** 重置数据 */
    resetData() {
      this.setBannerEnterRooms('init')
      this.setBannerCPMic('init')
      this.micGifts = []
      this.giftListAnimation = []
      this.effectGifts = []
    }
  }
})
